// extracted by mini-css-extract-plugin
export default {"container":"Header_container__QHdhu","logo":"Header_logo__ETTP4","logoLink":"Header_logoLink__TbenE","text":"Header_text__QhOkP","textLine":"Header_textLine__D0vbn"};